export default {
  tabs: {
    access: 'Zugang',
    notification_preferences: 'Benachrichtigungseinstellungen',
  },
  sections: {
    notification_preferences: {
      title: 'Benachrichtigungseinstellungen',
      form: {
        has_voice_call_reminders: {
          label: 'Automatische Anrufe über ausstehende Aufträge erhalten',
        },
        voice_reminders_phone_number: {
          label: 'Telefonnummer für eingehende Anrufe',
        },
        has_whatsapp_notifications: {
          label: 'Benachrichtigungen (z.B. Bestellungen pausiert) per WhatsApp senden',
        },
        whatsapp_phone_number: {
          label: 'WhatsApp-Telefonnummer',
        },
        has_order_email_notifications: {
          label: 'Bestellbenachrichtigungen per E-Mail versenden',
        },
        order_notifications_email: {
          label: 'E-Mail-Adresse für die Weiterleitung von Bestellbenachrichtigungen',
        },
      },
    },
    voice_calls: {
      title: 'Sprachanrufe',
    },
    whats_app_notifications: {
      title: 'WhatsApp-Benachrichtigungen',
    },
    order_email_notifications: {
      title: 'E-Mail-Benachrichtigungen bestellen',
    },
    access_control: {
      title: 'Zugangskontrolle',
      form: {
        company_ids: {
          label: 'Zugang zu Restaurants',
          tooltip: 'Ermöglicht den Zugang zu folgenden Restaurants (zusätzlich zu den Restaurants derselben Marke)',
        },
      },
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
